import React from "react";
import { connect } from "react-redux";
import {
    Label,
    Row,
    Col,
    Modal,
    Card,
    CardHeader,
    CardBody,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input,
} from "reactstrap";
import {
    Button,
    Typography,
    withStyles,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TablePagination,
    TableRow,
} from "@material-ui/core";

import { selectEWCCodes,canCreate,canDelete } from "./selectors";
import { getEWCList, setEWCCode, removeEWCCode } from "./actions";
import PropTypes from "prop-types";

import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

const actionsStyles = (theme) => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = (event) => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = (event) => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = (event) => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = (event) => {
        this.props.onChangePage(
            event,
            Math.max(
                0,
                Math.ceil(this.props.count / this.props.rowsPerPage) - 1
            )
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                    color="primary"
                >
                    {theme.direction === "rtl" ? (
                        <LastPageIcon />
                    ) : (
                        <FirstPageIcon />
                    )}
                </IconButton>
                <Button
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    color="primary"
                    aria-label="Previous Page"
                >
                    Previous Page{" "}
                    {theme.direction === "rtl" ? (
                        <KeyboardArrowRight />
                    ) : (
                        <KeyboardArrowLeft />
                    )}
                </Button>
                <Button
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                    color="primary"
                >
                    Next Page{" "}
                    {theme.direction === "rtl" ? (
                        <KeyboardArrowLeft />
                    ) : (
                        <KeyboardArrowRight />
                    )}
                </Button>
                <IconButton
                    color="primary"
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === "rtl" ? (
                        <FirstPageIcon />
                    ) : (
                        <LastPageIcon />
                    )}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
    withTheme: true,
})(TablePaginationActions);

const styles = () => ({
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 1,
        borderRadius: 5,
        backgroundColor: "#3f51b5",
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        marginTop: 1,
        padding: 0,
    },
});

class EWCCodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createModal: false,
            removeModal: false,
            page: 0,
            rowsPerPage: 50,
            ewcCodeKey: "",
            ewcDesc: "",
        };
        props.getEWCList();
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value });
    };
    render() {
        const list = this.props.ewcCodes === false ? [] : this.props.ewcCodes;
        const { classes } = this.props;
        const { rowsPerPage, page } = this.state;

        return (
            <Card>
                <CardHeader>
                    <Typography variant="h5">EWC Codes</Typography>
                </CardHeader>
                <CardBody>
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TablePagination
                                        colSpan={12}
                                        ActionsComponent={
                                            TablePaginationActionsWrapped
                                        }
                                        count={list.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={
                                            this.handleChangeRowsPerPage
                                        }
                                        rowsPerPageOptions={[50, 100]}
                                        //ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        <Typography variant="body2">
                                            <b>EWC Codes</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Descriptions</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Actions</b>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((e, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    <Typography variant="body1">
                                                        {e.ewc_code}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.description}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Button
                                                        disabled={this.props.canDelete===false}
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => {
                                                            this.setState({
                                                                createModal: false,
                                                                removeModal: true,
                                                                ewcCodeKey:
                                                                    e.ewc_code,
                                                                ewcDesc:
                                                                    e.description,
                                                            });
                                                        }}
                                                    >
                                                        Remove
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </div>

                    <Button
                        disabled={this.props.canCreate===false}
                        style={{ marginTop: "1%" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.setState({
                                createModal: true,
                                removeModal: false,
                            });
                        }}
                    >
                        Add
                    </Button>
                    <Modal isOpen={this.state.createModal}>
                        <ModalHeader>Add EWC Code And Description</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col xs="3">
                                    <Label for="input">
                                        Please Enter EWC Code
                                    </Label>
                                    <Input
                                        id="input"
                                        value={this.state.ewcCodeKey}
                                        onChange={(e) => {
                                            this.setState({
                                                ewcCodeKey: e.target.value,
                                            });
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Label for="desc">
                                        Please Enter EWC Description
                                    </Label>
                                    <Input
                                        style={{ marginTop: "24px" }}
                                        id="desc"
                                        value={this.state.ewcDesc}
                                        onChange={(e) => {
                                            this.setState({
                                                ewcDesc: e.target.value,
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={() => {
                                    this.setState({
                                        createModal: false,
                                        removeModal: false,
                                        wasteDisposalKey: "",
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                onClick={() => {
                                    this.setState({
                                        createModal: false,
                                        removeModal: false,
                                    });
                                    this.props.setEWCCode({
                                        description: this.state.ewcDesc,
                                        ewc_code: this.state.ewcCodeKey,
                                    });
                                }}
                            >
                                Submit
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={this.state.removeModal}>
                        <ModalHeader>Remove EWC Code</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col xs="3">
                                    <Label for="input">EWC Code</Label>
                                    <Typography variant="subheading">
                                        {this.state.ewcCodeKey}
                                    </Typography>
                                </Col>
                                <Col>
                                    <Label for="desc">EWC Description</Label>
                                    <Typography variant="subheading" id="desc">
                                        {this.state.ewcDesc}
                                    </Typography>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={() => {
                                    this.setState({
                                        createModal: false,
                                        removeModal: false,
                                        wasteDisposalKey: "",
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="secondary"
                                onClick={() => {
                                    this.setState({
                                        createModal: false,
                                        removeModal: false,
                                    });
                                    this.props.removeEWCCode(
                                        this.state.ewcCodeKey
                                    );
                                }}
                            >
                                Remove
                            </Button>
                        </ModalFooter>
                    </Modal>
                </CardBody>
            </Card>
        );
    }
}

export default connect(
    (store) => {
        return { ewcCodes: selectEWCCodes(store),
            canCreate:canCreate(store),
            canDelete:canDelete(store) };
    },
    { getEWCList, setEWCCode, removeEWCCode }
)(withStyles(styles)(EWCCodes));
